/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  IngestRequestBody,
  IngestRequestBody$Outbound,
  IngestRequestBody$outboundSchema,
} from "../components/ingestrequestbody.js";

export type IngestHookEventRequest = {
  /**
   * Optional API key for plugin-driven attribution.
   */
  gramKey?: string | undefined;
  /**
   * Optional project slug for plugin-driven attribution.
   */
  gramProject?: string | undefined;
  /**
   * Optional per-invocation token reused across retries so the server stores a redelivered event exactly once.
   */
  idempotencyKey?: string | undefined;
  /**
   * Set when the event is redelivered from a device's offline spool after control-plane downtime, under its original Idempotency-Key and occurred_at.
   */
  xGramReplayed?: boolean | undefined;
  ingestRequestBody: IngestRequestBody;
};

/** @internal */
export type IngestHookEventRequest$Outbound = {
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
  "Idempotency-Key"?: string | undefined;
  "X-Gram-Replayed"?: boolean | undefined;
  IngestRequestBody: IngestRequestBody$Outbound;
};

/** @internal */
export const IngestHookEventRequest$outboundSchema: z.ZodMiniType<
  IngestHookEventRequest$Outbound,
  IngestHookEventRequest
> = z.pipe(
  z.object({
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    idempotencyKey: z.optional(z.string()),
    xGramReplayed: z.optional(z.boolean()),
    ingestRequestBody: IngestRequestBody$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
      idempotencyKey: "Idempotency-Key",
      xGramReplayed: "X-Gram-Replayed",
      ingestRequestBody: "IngestRequestBody",
    });
  }),
);

export function ingestHookEventRequestToJSON(
  ingestHookEventRequest: IngestHookEventRequest,
): string {
  return JSON.stringify(
    IngestHookEventRequest$outboundSchema.parse(ingestHookEventRequest),
  );
}
